import Geocode from 'react-geocode';

export function fromLatLng({lat, lng}: {lat: number; lng: number}): Promise<any> {
    return Geocode.fromLatLng(
        lat.toString(),
        lng.toString(),
        process.env.REACT_APP_GOOGLE_MAPS_GEOCODING_API_KEY
    );
}
